import classNames from 'classnames';
import * as React from 'react';
import { styles } from './SeoText.styles';

export interface SeoTextProps {
  content: string;
  withoutMargin?: boolean;
}

const SeoText = (props: SeoTextProps) => {
  const { content, withoutMargin } = props;

  return (
    <div className={classNames('SeoText', {SeoText_withoutMargin: withoutMargin})}>
      <div className="SeoText__wrapper">
        <div
          className="SeoText__content"
          data-marker="seo text"
          dangerouslySetInnerHTML={ { "__html": content } }
        />
      </div>
      <style jsx>{ styles }</style>
    </div>
  );
};

export default SeoText;
